import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65e8cf1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "speakers" }
const _hoisted_2 = { class: "speakers__person-bio" }
const _hoisted_3 = { class: "speakers__person-bio-name" }
const _hoisted_4 = { class: "speakers__person-bio-detail" }
const _hoisted_5 = { class: "speakers__person-event-name" }

import {
  Person,
  peopleData,
  getPersonImage,
  isGoogleDataCorrupted,
  findPersonByName,
} from "@/components/usePeople"
import Image from "@/components/Image.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Speakers',
  props: {
    speakers: {},
    allEvents: {}
  },
  setup(__props: any) {

const props = __props

const getPersonEventName = (personName: string) => {
  const foundPersonEvent = props.allEvents.find(
    (event: any) => {
      return event.persons.find((person: any) => person.public_name === personName)
      }
  )
  return foundPersonEvent ? foundPersonEvent.title : ""
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speakers, (person) => {
      return (_openBlock(), _createElementBlock("div", {
        key: person.public_name,
        class: "speakers__person"
      }, [
        _createElementVNode("div", null, [
          _createVNode(Image, {
            cssClass: ['speakers__person-image', {'speakers__person-image--purple-filter': !Boolean(_unref(findPersonByName)(person) ? (_unref(findPersonByName)(person) as Person).isImageEdited : undefined)} ],
            src: _unref(getPersonImage)({person: _unref(findPersonByName)(person) as Person, peopleData: _unref(peopleData), isGoogleDataCorrupted: _unref(isGoogleDataCorrupted) }),
            fallbackImageA: _unref(getPersonImage)({person: _unref(findPersonByName)(person) as Person, isFallback: true, isGoogleDataCorrupted: _unref(isGoogleDataCorrupted)}),
            fallbackImageB: require('../../assets/people/default.jpg')
          }, null, 8, ["cssClass", "src", "fallbackImageA", "fallbackImageB"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(person.public_name), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(person.biography), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(getPersonEventName(person.public_name)), 1)
        ])
      ]))
    }), 128))
  ]))
}
}

})